import { ReactNode, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "@unleashed/hooks/useLocalStorage";
import { useAdminSelector } from "../../../stores/AdminStore";

interface IdleGuardProps {
  children?: ReactNode | ReactNode[];
}

export const IdleGuard = ({children}: IdleGuardProps) => {
  const lastActiveDateKey = `${import.meta.env.MODE}_last_active_date`;
  const navigate = useNavigate();
  const storage = useLocalStorage();
  const config = useAdminSelector(s => s.config);
  const onIdle = () => {
    navigate(`/sign-out?from=${location.pathname}`);
  };

  const onAction = () => {
    storage.set<number>(lastActiveDateKey, new Date().getTime());
  };

  useEffect(() => {
    const lastActiveDate = storage.get<number>(lastActiveDateKey);
    if (lastActiveDate && new Date().getTime() - lastActiveDate > config.timeoutInSeconds * 1000) {
      navigate(`/sign-out?from=${location.pathname}`);
    }
  }, [storage, navigate, config, lastActiveDateKey]);

  useIdleTimer({
    onIdle,
    onAction,
    timeout: config.timeoutInSeconds * 1000,
    crossTab: true,
    leaderElection: true,
    syncTimers: 200,
    debounce: 1000
  });

  if (!config) {
    return null;
  }

  return (
    <>
      {children}
    </>
  );
};
